import { useThemeContext } from "@/react/providers";
import type { Space } from "@/react/types/Space";
import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";

export const useSpacesForFilters = ({
  spaces,
  valueKey = "slug",
}: {
  spaces: Space[];
  valueKey?: keyof Space;
}) => {
  const { currentAppearance } = useThemeContext();
  return spaces.map((record: Space) => {
    const label = record.name;
    const richLabel = (
      <>
        <EmojiRenderer
          className="mr-1 inline !h-5 !w-5 align-text-top"
          emoji={record.emoji}
          appearance={currentAppearance}
          customEmojiUrl={record.custom_emoji_url}
          customEmojiDarkUrl={record.custom_emoji_dark_url}
        />
        <span>{record.name}</span>
      </>
    );

    return {
      richLabel,
      label,
      // eslint-disable-next-line @typescript-eslint/no-base-to-string -- Updating typescript-eslint, should be fixed when appropriate
      value: record[valueKey]?.toString() ?? "",
    };
  });
};
